import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from "./authinterceptor";
import AuthHeader from "../services/auth.header";

export const getAllSubsites = createAsyncThunk('subsite/getAllSubsites', async (range, thunkApi) => {
    try {
        console.log("SUBSITE REQUEST");
        const response = await axios.get(process.env.REACT_APP_API_URL + "/admin/subsites?range=" + JSON.stringify(range), { headers: AuthHeader.authHeaderFromState(thunkApi.getState())});
        console.log("SUBSITE RESPONSE" , response);
        return response.data;
    } catch (error) {
        console.log(error);
    }    
  });
  
  export const createSubsite = createAsyncThunk('subsite/', async (newSubsite, {rejectWithValue}) => {
    try {
      const response = await axios.post(process.env.REACT_APP_API_URL + "/subsite/create", 
          newSubsite,
          { headers: AuthHeader.authHeader() }
        );
        console.log("RESPONSE", response);
        return response.data;
    } catch (error) {
      console.log("ERROR RESPONSE", error);
      return rejectWithValue(error.response.data);
    }    
  });

  export const allSubsites = state => state.subsite.subsites;
  export const subsiteTotalCount = state => state.subsite.subsiteTotalCount;
  export const createStatus = state => state.subsite.createStatus;
  export const errorMessage = state => state.users.error;

  const initialState = {
    subsites: [],
    status: 'idle',
    error: null,
    subsiteTotalCount: 0,
    createStatus: 'idle',
    newSubsite: null
  };

  const subsiteSlice = createSlice({
    name: 'subsite',
    initialState,
    reducers: {},
    extraReducers(builder) {
        builder
          .addCase(getAllSubsites.pending, (state, action) => {
            state.status = 'loading'
          })
          .addCase(getAllSubsites.fulfilled, (state, action) => {
            state.status = 'succeeded'
            state.subsites = action.payload.data;
            state.subsiteTotalCount = action.payload.count;
          })
          .addCase(getAllSubsites.rejected, (state, action) => {
            state.status = 'failed'
            state.error = action.error.message
          })
          .addCase(createSubsite.pending, (state, action) => {
            console.log("PENDING", action);
            state.createStatus = 'loading';
            state.error = "";
          })
          .addCase(createSubsite.fulfilled, (state, action) => {
            console.log("SUCCESS", action);
            state.createStatus = 'succeeded';
            state.newSubsite = action.payload;
            state.subsites.push(action.payload);
            state.error = "";
          })
          .addCase(createSubsite.rejected, (state, action) => {
            console.log("ACTION", action);
            state.createStatus = 'failed';
            state.error = action.payload.message;
          })
      }
  });
  
  export default subsiteSlice.reducer;




